// Version : 0.0.1
// Author : AGALYA

import progressReportTypes from './progress-report.types';

/************** GET PROGRESS REPORT START **************************** */
export const getProgressReportStart = (data: any) => ({
	type: progressReportTypes.GET_PROGRESS_REPORT_START,
	payload: data,
});

export const getProgressReportSuccess = (data: any) => ({
	type: progressReportTypes.GET_PROGRESS_REPORT_SUCCESS,
	payload: data,
});

export const getProgressReportFailure = (error: any) => ({
	type: progressReportTypes.GET_PROGRESS_REPORT_FAILURE,
	payload: error,
});

export const getProgressReportReset = () => ({
	type: progressReportTypes.GET_PROGRESS_REPORT_RESET,
});

export const getProgressReportChanged = () => ({
	type: progressReportTypes.GET_PROGRESS_REPORT_CHANGED,
});

/************** GET PROGRESS REPORT END **************************** */
